<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Beheer uw tijd schema's</h4>
            <p>U kunt hier uw tijdschema's zoals openingstijden registeren. Deze kunnen dan vervolgens eventueel gekoppeld worden aan een point of interest zodata 
                meldingen alleen worden getriggered binnen (of buiten) deze schema's.
            </p>
        
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">      
      <v-flex xs12 md12 lg6 xl5 pt-2>          
          <v-widget title="Tijd schema's beheren" class="" title-text-color="">
            <v-btn fab dark  color="accent" slot="button-top-right" @click="newTimeTable()" v-if="!selectedTimeTable">
                <v-icon dark>add</v-icon>
            </v-btn>  
            <v-layout slot="widget-content">                                                        
              <v-layout row wrap slot="content">
                  <v-flex xs12 sm12 lg12 v-if="!selectedTimeTable">
                    <v-card-text>
                    <v-list dense> 
                      <v-list-tile v-for="time in timeTables" :key="time.id" active-class="primary darken-2" @click="loadForm(time)" avatar>
                          <v-list-tile-avatar> <i class="far fa-clock fa-1x primary--text text--lighten-2"></i>  </v-list-tile-avatar>                      
                          <v-list-tile-title>{{time.name}}</v-list-tile-title>                                               
                      </v-list-tile>                  
                    </v-list>                
                    </v-card-text>
                  </v-flex>
                  <v-flex  v-if="selectedTimeTable" px-3 py-3> 
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                    <v-flex>                                    
                      <v-text-field                    
                        v-model="selectedTimeTable.name"                     
                        label="Naam"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                      </v-flex>
<!-- TIMETABLE ---------------------------------------------------------------------------->
                      <v-flex xs12>
                      <!-------- MONDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day1Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day1From" type="text" label="Maandag vanaf" :error="day1FromError" :required="day1Active" :disabled="!day1Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day1Till" type="text"  label="Maandag tot"  :error="day1TillError"  :required="day1Active" :disabled="!day1Active"></time-picker>
                            </v-flex>
                          </v-layout>
                      <!-------- TUESDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day2Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day2From" type="text"  label="Dinsdag vanaf" :error="day2FromError" :required="day2Active" :disabled="!day2Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day2Till" type="text"  label="Dinsdag tot" :error="day2TillError"  :required="day2Active" :disabled="!day2Active"></time-picker>
                            </v-flex>
                          </v-layout>
                      <!-------- WEDNESDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day3Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day3From" type="text"  label="Woensdag vanaf" :error="day3FromError" :required="day3Active" :disabled="!day3Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day3Till" type="text"  label="Woensdag tot" :error="day3TillError"  :required="day3Active" :disabled="!day3Active"></time-picker>
                            </v-flex>
                          </v-layout>
                      <!-------- THURSDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day4Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day4From" type="text"  label="Donderdag vanaf" :error="day4FromError" :required="day4Active" :disabled="!day4Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day4Till" type="text"  label="Donderdag tot" :error="day4TillError" :required="day4Active" :disabled="!day4Active"></time-picker>
                            </v-flex>
                          </v-layout>                        
                      <!-------- FRIDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day5Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day5From" type="text"  label="Vrijdag vanaf" :error="day5FromError" :required="day5Active" :disabled="!day5Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day5Till" type="text"  label="Vrijdag tot" :error="day5TillError" :required="day5Active" :disabled="!day5Active"></time-picker>
                            </v-flex>
                          </v-layout>   
                      <!-------- SATURDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day6Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day6From" type="text"  label="Zaterdag vanaf" :error="day6FromError"  :required="day6Active" :disabled="!day6Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day6Till" type="text"  label="Zaterdag tot" :error="day6TillError"  :required="day6Active" :disabled="!day6Active"></time-picker>
                            </v-flex>
                          </v-layout>         
                      <!-------- SUNDAY ---------------------------------------------------------------------------------------------------->
                          <v-layout row>
                            <v-flex xs2>
                              <v-checkbox v-model="day7Active"></v-checkbox>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day7From" type="text"  label="Zondag vanaf" :error="day7FromError"  :required="day7Active" :disabled="!day7Active" ></time-picker>
                            </v-flex>
                            <v-flex xs5>
                              <time-picker v-model="selectedTimeTable.day7Till" type="text"  label="Zondag tot" :error="day7TillError"  :required="day7Active" :disabled="!day7Active"></time-picker>
                            </v-flex>
                          </v-layout>                                          
                      </v-flex>
<!-- BUTTON BAR --------------------------------------------------------------------------->                      
                      <v-flex row >                  
                        <v-layout >
                          <v-btn                          
                              color="info"                      
                              @click="clearCurrent"> 
                              annuleren
                            </v-btn>                                                                                                         
                            <v-spacer></v-spacer>
                            <v-btn                                                
                              color="error"
                              > 
                              Verwijder
                            </v-btn>                                           
                            <v-btn                                                
                              color="success"
                              @click="saveForm">
                              Opslaan
                            </v-btn>                        
                        </v-layout>                                                                    
                      </v-flex>                 
                    </v-form>
                  </v-flex>
                </v-layout>    
              </v-layout>              
          </v-widget>
        </v-flex>
    </v-layout>  
  </v-layout>
</template>
<script>
 
import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import TopInfoPanel from "../../components/global/TopInfoPanel"
import VWidget from "../../components/global/VWidget"
import DdPage from '../../components/global/DdPage'
import TimePicker from '../../components/form/TimePicker'


export default {
  components: {
    VWidget,
    DdPage,
    TopInfoPanel,
    TimePicker
  },
  data() {
    return  {
      day1FromError:false,  
      day1TillError:false,      
      day2FromError:false,      
      day2TillError:false,      
      day3FromError:false,          
      day3TillError:false,      
      day4FromError:false,          
      day4TillError:false,      
      day5FromError:false,  
      day5TillError:false,      
      day6FromError:false,      
      day6TillError:false,      
      day7FromError:false,          
      day7TillError:false,      
      day1Active:true,
      day2Active:true,
      day3Active:true,
      day4Active:true,
      day5Active:true,                  
      day6Active:false,                        
      day7Active:false,                              
      menu1:false,
      valid:true,     
      daysValid:true,
      selectedTimeTable:null,
      nameRules:[
        v => !!v || "Naam is verplicht"
      ]
    }
  },
  computed: {
    ...mapGetters({
      timeTables: types.TIME_TABLES
    })
  },
  methods: {
    saveForm(){
      // first validate day data
      this.validateDaysData()

      // save if both day and 
      if (this.$refs.form.validate() && this.daysValid) {      
        this.$store.dispatch(types.SAVE_TIME_TABLE, {data:this.selectedTimeTable} ).then((res) => {            
            // reload list after save                     
            this.$store.dispatch(types.TIME_TABLES,{}).then(() => {                                    
                //this.selectedAssetGroup = this.assetGroups.find( (item) => item.id == res.id)
                this.clearCurrent();
            })       
        });
      }
    },
    validateDaysData(){

      this.daysValid = true
      let vm = this
      let save = {};
      for(let i=1;i<=7; i++){
         let from = "day"+i+"From" 
         let till = "day"+i+"Till" 
         let active = "day"+i+"Active"

         if(vm[active]){
           vm[from+"Error"] = !this.selectedTimeTable[from] ? true:false            
           vm[till+"Error"] = !this.selectedTimeTable[till] ? true:false      
           
           if(vm[from+"Error"] || vm[till+"Error"]){
             this.daysValid = false
           }
         }
         else{
           vm[from+"Error"] = false
           vm[till+"Error"] = false
           
           this.selectedTimeTable[from] = null
           this.selectedTimeTable[till] = null           
         }
      }      
    },
    emptyFields(dayNr){
      this.selectedTimeTable["day"+dayNr+"From"] = ""
      this.selectedTimeTable["day"+dayNr+"Till"] = "" 
    },
    loadForm(timeTable){
      let selectedTimeTable={}
      Object.assign(selectedTimeTable, timeTable)
      this.selectedTimeTable = selectedTimeTable

      this.prepareForm()

    },
    prepareForm(){
        for(let i=0;i<=7;i++){
          let fieldFrom = "day"+i+"From"
          let fieldTill = "day"+i+"Till"
          let dayActive = "day"+i+"Active"

          if(this.selectedTimeTable[fieldFrom]){
            let from = this.selectedTimeTable[fieldFrom].split(":")
            let till = this.selectedTimeTable[fieldTill].split(":")
            this.selectedTimeTable[fieldFrom] = from[0]+":"+from[1]
            this.selectedTimeTable[fieldTill] = till[0]+":"+till[1]
            this[dayActive] = true
          }
          else{
            this[dayActive] = false
          }
        }
    },
    deleteTimeTable(){
        this.$store.dispatch(types.DELETE_TIME_TABLE, {data:{id:this.selectedTimeTable.id}} ).then(() => {
          this.$store.dispatch(types.TIME_TABLES,{})
          this.clearCurrent();
        })      
    },
    clearCurrent(){
      this.selectedTimeTable = null        
    },
     newTimeTable(){
      this.selectedTimeTable  = {id:"",
                                name:"",
                                day1From:"",
                                day1Till:"",
                                day2From:"",
                                day2Till:"",
                                day3From:"",
                                day3Till:"",
                                day4From:"",
                                day4Till:"",
                                day5From:"",
                                day5Till:"",
                                day6From:"",
                                day6Till:"",
                                day7From:"",
                                day7Till:""}
      this.day1Active = true                            
      this.day2Active = true
      this.day3Active = true
      this.day4Active = true
      this.day5Active = true
      this.day6Active = false
      this.day7Active = false     

    },
    loadTimeTable(){      
      this.$store.dispatch(types.TIME_TABLES,{params:{per_page:200}})
    }
  },
  mounted() {
    this.loadTimeTable()
    this.clearCurrent()
    this.$store.dispatch(types.BACKGROUND_ICON, 'cogs')
  },  
  beforeDestroy(){
    this.$store.dispatch(types.BACKGROUND_ICON, null)
  }  
}
</script>
<style>
.dd-detail-list li{
  list-style-type: none;
  padding-bottom: 4px;
  padding-left: 4px;
  border-bottom: 1px solid black;
  background-color: blue-gey lighten-5;
}
</style>
